import _get from 'lodash/get';

import { Pixall } from 'reaxl-analytics-handlers';

export function seeMoreButtonClick({
    data = {},
    dataLayer = {},
    state,
}, option = {}) {
    const pageId = _get(dataLayer, 'page.brandPg') || _get(dataLayer, 'page.pg', '');
    const payload = {
        eventSource: 'button',
        eventType: 'click',
        program: 'DealerDotCom',
        label: 'load-more-results',
        pageId,
        pageType: 'srp',
    };

    Pixall.sendClickEvent(payload, dataLayer, option);
    return {};
}
